import { createSlice } from "@reduxjs/toolkit";
import myLocalStorage from "../../utils/myLocalStorage";
import { validationValue } from "../../utils/validations";

const initialState = {
  ofAndPart: validationValue(myLocalStorage.get("ofAndPart"), {}),
  assignedParts: validationValue(myLocalStorage.get("assignedParts"), [])
};

const trackingSlices = createSlice({
  name: "tracking",
  initialState,
  reducers: {
    changeOfAndPart: (state, action) => {
      const main = action.payload;
      myLocalStorage.set("ofAndPart", main);
      state.ofAndPart = main;
    },
    clearOfAndPart: (state, action) => {
      myLocalStorage.remove("ofAndPart");
      state.ofAndPart = {};
    },
    changeAssignedParts: (state, action) => {
      const parts = action.payload;
      myLocalStorage.set("assignedParts", parts);
      state.assignedParts = parts;
    },
    clearAssignedParts: (state, action) => {
      myLocalStorage.remove("assignedParts");
      state.assignedParts = [];
    }
  }
});

export const {
  changeOfAndPart,
  clearOfAndPart,
  changeAssignedParts,
  clearAssignedParts
} = trackingSlices.actions;

export default trackingSlices.reducer;
